import { checkingPreload, unCheckingPreload } from '../loading/thunks';
import { 
    getShiftSchedulingGlobalRulesService, 
    postShiftSchedulingGlobalRulesService, 
    putShiftSchedulingGlobalRulesService 
} from '../../services/shift-scheduling-global-rules.service';
import { setShiftSchedulingGlobalRules, setShiftSchedulingGlobalRule } from './slice';

export const getShiftSchedulingGlobalRulesStore = (): any => {
    return async (dispatch: any) => {
        try {
            await dispatch(checkingPreload());
            const result = await getShiftSchedulingGlobalRulesService();
            if (result.ok) {
                dispatch(setShiftSchedulingGlobalRules(result.data ? [result.data] : []));
                dispatch(setShiftSchedulingGlobalRule(result.data || null));
            }
            dispatch(unCheckingPreload());
            return result;
        } catch (error) {
            console.log('getShiftSchedulingGlobalRulesStore ', error);
            dispatch(unCheckingPreload());
        }
    }
}

export const postShiftSchedulingGlobalRulesStore = (data: any): any => {
    return async (dispatch: any) => {
        try {
            await dispatch(checkingPreload());
            const result = await postShiftSchedulingGlobalRulesService(data);
            dispatch(unCheckingPreload());
            return result;
        } catch (error) {
            console.log('postShiftSchedulingGlobalRulesStore ', error);
            dispatch(unCheckingPreload());
        }
    }
}

export const putShiftSchedulingGlobalRulesStore = (id: string, data: any): any => {
    return async (dispatch: any) => {
        try {
            await dispatch(checkingPreload());
            const result = await putShiftSchedulingGlobalRulesService(id, data);
            dispatch(unCheckingPreload());
            return result;
        } catch (error) {
            console.log('putShiftSchedulingGlobalRulesStore ', error);
            dispatch(unCheckingPreload());
        }
    }
}
